import layout from '@/layout'

export default {
  path: '/permission',
  component: layout,
  redirect: '/permission/admin',
  name: 'permissionRole',
  meta: {
    title: 'permission',
    icon: 'lock'
  },
  children: [
    {
      path: '/permission/role',
      name: 'permissionRole',
      component: () => import('@/views/permission/role/index'),
      meta: {
        title: 'permissionRole',
        icon: 'role'
      }
    }
  ]
}
